import { Link, navigate, routes, useParams } from '@cedarjs/router'
import { faHomeAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, ButtonBase, IconButton, useColorScheme } from "@mui/material"
import { AnimatePresence, LayoutGroup } from "framer-motion"
import LogoLisaqua from "src/assets/Lisaqua_logo.png"
import LogoLisaquaDark from "src/assets/Lisaqua_logo_dark.png"
import { useAuth } from "src/auth"
import { useDateStore, useStateStore } from "src/lib/store"
import { useLoadStateBasedOnRoute } from "src/lib/useLoadStateBasedOnRoute"
import LisaquaLogo from "../../assets/lisaqua_logo_blue.png"
import LisaquaLogoWhite from "../../assets/lisaqua_small_white.webp"
import AnimatedEnteringBlock from "../AnimatedEnteringBlock/AnimatedEnteringBlock"
import AnimatedSlidingBlock from "../AnimatedSlidingBlock/AnimatedSlidingBlock"
import AuthenticatedUserMenu from "../AuthenticatedUserMenu/AuthenticatedUserMenu"
import HeaderBatchInfos from "../HeaderBatchInfos/HeaderBatchInfos"
import HeaderSiteInfos from "../HeaderSiteInfos/HeaderSiteInfos"
import HeaderTankInfos from "../HeaderTankInfos/HeaderTankInfos"
import WorkDatePicker from "../WorkDatePicker/WorkDatePicker"


const Header = () => {
  const { loading, isAuthenticated } = useAuth()
  const { idSite, idTank, idBatch } = useParams()
  const isDateToday = useDateStore((state) => state.isDateToday());
  const [siteQuery, tankQuery, batchQuery] = useLoadStateBasedOnRoute({ idSite, idTank, idBatch })
  const [site, tank, batch] = useStateStore(state => [state.site, state.tank, state.batch]);
  //Prevents auto layout animation glitch if the state of the scroll is preveserved on page change
  const isScrollAtTop = window.scrollY == 0

  const { colorScheme } = useColorScheme()
  return (
    <div className={`w-full h-20 flex sm:grid grid-cols-12 items-center justify-between bg-slate-50/40 backdrop-blur-xl dark:bg-dark-950/60 shadow-md relative z-30 `}>
      <div className="col-span-3 flex shrink-0">
        <ButtonBase onClick={() => navigate(routes.home())} className="mx-2 rounded-lg sm:block hidden"><img src={colorScheme == "light" ? LogoLisaqua : LogoLisaquaDark} className="rounded-lg h-16" /></ButtonBase>
        <div>
          <WorkDatePicker className={`${!isDateToday && " !bg-orange-200 dark:!bg-orange-950 h-16"}`} />
        </div>
      </div>
      <div className="col-span-6 flex align-items-center justify-center items-center flex-grow text-center sm:flex-row flex-col sm:gap-6">
        <AnimatePresence mode="wait">
          {!idSite && !idTank && !idBatch && <AnimatedEnteringBlock key="header-logo" layout><Link to="/" className="no-underline dark:text-white/80 text-black"><img src={colorScheme == "light" ? LisaquaLogo : LisaquaLogoWhite} className="w-32 mx-auto" /></Link></AnimatedEnteringBlock>}
          {site && <AnimatedEnteringBlock key="header-site" layout={isScrollAtTop} slideX className="flex justify-center items-center">
            <IconButton onClick={() => navigate(routes.home())} className="sm:hidden  text-blue-400"><FontAwesomeIcon icon={faHomeAlt} className="text-lg" /></IconButton>
            <Link to={`/${site.id}`} className="no-underline dark:text-white/80 text-black"><HeaderSiteInfos className={siteQuery.loading ? "animate-pulse" : ""} infos={site} /></Link>
          </AnimatedEnteringBlock>}
          <LayoutGroup>
            {site && tank && <AnimatedSlidingBlock key="header-tanks" ><HeaderTankInfos tank={tank} className={tankQuery.loading ? "animate-pulse" : ""} /></AnimatedSlidingBlock>}
            {!tank && batch && <AnimatedSlidingBlock key="header-batch" ><HeaderBatchInfos batch={batch} className={batchQuery.loading ? "animate-pulse" : ""} /></AnimatedSlidingBlock>}
          </LayoutGroup>
        </AnimatePresence>
      </div>
      <AnimatePresence mode="wait">
        <div className="col-span-3 flex flex-col items-end px-6 shrink-0">
          {!loading ?
            (isAuthenticated ? (
              <AnimatedEnteringBlock key="user-menu" layout>
                <AuthenticatedUserMenu />
              </AnimatedEnteringBlock>
            ) : (
              <Link to={routes.login()}><Button className="mr-2" sx={{ textTransform: "none" }}>Connexion</Button></Link>
            )) : <></>}
        </div>
      </AnimatePresence>
    </div>
  )
}

export default Header
